// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1438":"1c9be343","2258":"1c9be343","3596":"1071340f","6865":"3a7cfa9b"}[chunkId] + ".chunk.css";
};